module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-notification-group",
    style: (_vm.styles)
  }, [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "name": _vm.animationName
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave,
      "after-leave": _vm.clean
    }
  }, _vm._l((_vm.active), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "vue-notification-wrapper",
      style: (_vm.notifyWrapperStyle(item)),
      attrs: {
        "data-id": item.id
      },
      on: {
        "mouseenter": _vm.pauseTimeout,
        "mouseleave": _vm.resumeTimeout
      }
    }, [_vm._t("body", function() {
      return [_c('div', {
        class: _vm.notifyClass(item),
        on: {
          "click": function($event) {
            return _vm.destroyIfNecessary(item)
          }
        }
      }, [(item.title) ? _c('div', {
        staticClass: "notification-title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "notification-content",
        domProps: {
          "innerHTML": _vm._s(item.text)
        }
      })])]
    }, {
      "item": item,
      "close": function () { return _vm.destroy(item); }
    })], 2)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55210eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Notifications.vue
// module id = 15
// module chunks = 0